import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/user/staff/workflows")({
  staticData: { application: "Pricing" },
});
